import { styled } from 'goober';
import { forwardRef } from 'react';

const badgeSize = 30;
const badgeOverlap = -8;

export const Avatar = styled(
    'div',
    forwardRef
)<{ $idx?: number; $variant?: 'primary' | 'neutral' }>(({ theme, $idx, $variant = 'neutral' }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: {
        primary: theme.colors.primary.w50,
        neutral: theme.colors.neutral.w200,
    }[$variant],
    color: {
        primary: theme.colors.primary.w500,
        neutral: theme.colors.neutral.w900,
    }[$variant],
    fill: {
        primary: theme.colors.primary.w500,
        neutral: theme.colors.neutral.w900,
    }[$variant],
    borderRadius: '50%',
    marginLeft: $idx ? `${badgeOverlap}px` : 0,
    width: `${badgeSize}px`,
    height: `${badgeSize}px`,
    border: '2px solid #fff',
    flexShrink: 0,

    textAlign: 'center',
    fontWeight: 500,
    textTransform: 'uppercase',
    fontSize: theme.font.smallSize,
}));

export const AvatarBadgesContainer = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    maxWidth: '100%',
}));

export const AvatarContainer = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    borderRadius: '100%',

    p: {
        margin: 0,
        padding: 0,
        display: 'inline',
        textAlign: 'center',
        fontWeight: 'bold',
    },
}));

export const AvatarImage = styled('img')({
    width: '100%',
    height: '100%',
    borderRadius: '100%',
    objectFit: 'cover',
});
